import { Icon, IconProps } from './Icon';

export type FlashProps = IconProps;

export const Flash = (props: FlashProps) => (
  <Icon width="16px" height="16px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M8.667 1.333 2.729 8.46c-.233.279-.349.418-.35.536-.002.102.043.2.123.264.092.074.273.074.637.074h4.86l-.666 5.334 5.938-7.126c.232-.279.349-.418.35-.536a.333.333 0 0 0-.123-.264c-.092-.074-.273-.074-.637-.074H8l.667-5.334Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
